__turbopack_context__.v({
  "close-button": "ImageGalleryModal-module-scss-module__y5fiFG__close-button",
  "image-zoom-wrapper": "ImageGalleryModal-module-scss-module__y5fiFG__image-zoom-wrapper",
  "layouts-container": "ImageGalleryModal-module-scss-module__y5fiFG__layouts-container",
  "main-image": "ImageGalleryModal-module-scss-module__y5fiFG__main-image",
  "mobile-hint": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-hint",
  "mobile-image": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-image",
  "mobile-image-wrap": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-image-wrap",
  "mobile-layout": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-layout",
  "mobile-main": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-main",
  "mobile-thumb": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-thumb",
  "mobile-thumb--active": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-thumb--active",
  "mobile-thumb-item": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-thumb-item",
  "mobile-thumbs": "ImageGalleryModal-module-scss-module__y5fiFG__mobile-thumbs",
  "modal": "ImageGalleryModal-module-scss-module__y5fiFG__modal",
  "modal-image": "ImageGalleryModal-module-scss-module__y5fiFG__modal-image",
  "shared-video-player": "ImageGalleryModal-module-scss-module__y5fiFG__shared-video-player",
  "thumbnail": "ImageGalleryModal-module-scss-module__y5fiFG__thumbnail",
  "thumbnail--active": "ImageGalleryModal-module-scss-module__y5fiFG__thumbnail--active",
  "thumbnails": "ImageGalleryModal-module-scss-module__y5fiFG__thumbnails",
  "video-player": "ImageGalleryModal-module-scss-module__y5fiFG__video-player",
  "zoom-hint": "ImageGalleryModal-module-scss-module__y5fiFG__zoom-hint",
});
